export const generalServices = [
    {
        "title": "SERVICIOS </br> <span>INDUSTRIALES</span>",
        "description": "Contamos con la experiencia y el personal capacitado para construir o darle mantenimiento a su proyecto industrial. Nos adaptamos a sus necesidades de forma práctica y segura.",
        "link": "/servicios/industriales"
    },
    {
        "title": "SERVICIOS </br> <span>RESIDENCIALES</span>",
        "description": "Contamos con servicios Residenciales de mantenimiento como la Restauración, Limpieza en Alturas, Pintura, Acabados e Instalaciones para su inmueble.",
        "link": "/servicios/residenciales"
    },
    {
        "title": "SERVICIOS </br> <span>COMERCIALES</span>",
        "description": "Contamos con Servicios Comerciales de mantenimiento y Restauración en zonas de difícil acceso las cuales requieren de experiencia para un trabajo bien ejecutado.",
        "link": "/servicios/comerciales"
    }
];

export const generalServicesEn = [
    {
        title: "INDUSTRIAL <br /> <span>SERVICES</span>",
        description:
            "We have the expertise and qualified personnel to build or maintain your industrial project. We adapt to your requirements in a practical and safe manner.",
        link: "/servicios/residenciales"
    },
    {
        title: "RESIDENTIAL <br /> <span>SERVICES</span>",
        description:
            "We offer residential maintenance services such as restoration, high-altitude cleaning, painting, finishes, and installations for your property.",
        link: "/servicios/residenciales"
    },
    {
        title: "COMMERCIAL <br /> <span>SERVICES</span>",
        description:
            "We provide commercial maintenance and restoration services in hard-to-reach areas that demand expertise for a job well done.",
        link: "/servicios/comerciales"
    }
];

